export const REQUIRED_FIELD_RULES = [{ required: true, message: '请填写此项' }]

// 将错误字段放到视口中部，避免固定页头和底部操作栏遮挡标签、控件及错误提示。
export const FORM_ERROR_SCROLL_OPTIONS = { block: 'center', scrollMode: 'always', focus: true } as const
